import type {CopilotChatReference} from '@github-ui/copilot-chat-types'
import {createContext, use} from 'react'

export interface ContentPreviewBlockContext {
  messageId: string
  messageIndex: number
  messageTimestamp: string
  autoOpenPreviewPane: boolean
  markdown: string
  hasAutoOpenedPreviewPaneRef: React.RefObject<boolean>
  setHasAutoOpenedPreviewPane: (value: boolean) => void
  /**
   * Structured references attached to the message, used by inline markdown
   * extensions to look up payloads (e.g. an issue/PR/task list referenced
   * by id from a fenced code block placeholder).
   */
  references?: CopilotChatReference[]
}

export const ContentPreviewBlockContext = createContext<ContentPreviewBlockContext | null>(null)

export const useContentPreviewBlockContext = () => {
  const context = use(ContentPreviewBlockContext)

  if (!context) throw new Error('Missing required ContentPreviewBlockContext provider.')

  return context
}
